export const DEFAULT_RECURRING_AMOUNT = 20;
export const DEFAULT_PROJECTED_AGE = 65;

export const DEFAULT_MULTIPLIER = 1.08;
export const DEFAULT_RATE_OF_RETURN = 8;

export const DEFAULT_CONTRIBUTE_AFTER_18 = true;

export const NODE_COUNT = 80;

export const MIN_CONTRIBUTION_AGE = 18;

export const DEFAULT_DEPOSIT_ADJUSTMENT = 5;

export const MIN_DEPOSIT_AMOUNT = 0;
export const RESTRICTED_MIN_DEPOSIT_AMOUNT = 50;
export const MAX_DEPOSIT_AMOUNT = 5000;

export const DEFAULT_INITIAL_DEPOSIT_ADJUSTMENT = 5;

export const MIN_INITIAL_DEPOSIT = 0;
export const MAX_INITIAL_DEPOSIT = 100000;

export const MAX_PERCENTAGE = 20;
export const MIN_PERCENTAGE = 1;
export const MAX_RETIREMENT_AGE = 120;
export const MIN_CURRENT_AGE = 1;

export const DEFAULT_CALCULATOR_PERCENTAGE_INPUT = 10;
export const DEFAULT_CALCULATOR_MULTIPLIER = 1.1;
export const DEFAULT_CURRENT_AGE = 0;

export const DASHBOARD_CHART_DIMENSIONS = 335;
